import React from "react";
import CustomTable from "../../../helpers/customtable";
import "../../../../css/EmployeesTable.css";

export default function EmployeesList({ employees, t, translateRole, onEmployeeClick, loading = false }) {
  const column = (key, header, width) => ({
    key, header: t(header), shortHeader: t(`employeesHeaderShort_${header}`),
    width, align: "left", default: t("none"),
  });
  const config = {
    rowKey: "userId",
    emptyText: t("employeesTableEmpty"),
    pageSize: 10,
    showPageSizeSelector: true,
    pageSizeOptions: [10, 25, 50, 100],
    showTotalCount: true,
    labels: { filter: t("filter"), search: t("search") },
    columns: [
      column("userId", "id", "8%"),
      { ...column("name", "name", "20%"), fixed: true },
      column("email", "email", "22%"),
      column("username", "username", "16%"),
      column("roleLabel", "role", "14%"),
      column("address", "address", "20%"),
    ],
    onRowClick: (employee) => onEmployeeClick(employee.userId),
  };
  const rows = employees.map((employee) => ({ ...employee, roleLabel: translateRole(employee.role) }));

  return <div className="employees-table"><CustomTable data={rows} config={config} loading={loading} /></div>;
}
